export const isEmpty = (obj) => {
  return Object.keys(obj).length === 0;
};
